import { useLocation, useParams, useHistory } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { ArrowBack, } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useAuth } from "./context/AuthContext";

// mismo padding lateral que el header (en mobile el Container deja sólo 16px)
export const PADDING_COMO_HEADER = { px: { xs: "35px", md: 3 } };

export const Header = ({ evento }) => {
  const { user } = useAuth();
  const location = useLocation();
  const param = useParams();
  const history = useHistory();
  const [titulo, setTitulo] = useState('')
  const [subtitulo, setSubtitulo] = useState('');
  const [icono, setIcono] = useState('');
  const { t } = useTranslation("global");
  const [showBackButton, setShowBackButton] = useState(true);

  const isVentaPresencial = location.pathname.includes('/venta-presencial');

  const participacion = user?.participaciones?.find(
    (p) => p.idevento === Number(param.id)
  );

  const esVendedorOTesorero = participacion && (participacion.idrol === 9 || participacion.idrol === 10);

  useEffect(() => {
    const url = "/eventos/" + param.id;

    setShowBackButton(location.pathname !== url)
  }, [location.pathname, param.id]);

  useEffect(() => {
    const url = "/eventos/" + param.id;

    switch (location.pathname) {
      case url:
        setTitulo('')
        setSubtitulo('');
        break;
      case url + "/ubicaciones":
        setTitulo("Ubicaciones");
        setSubtitulo('');
        break;
      case url + "/tarifas":
        setTitulo("Entradas y precios");
        setSubtitulo("Los tickets dan acceso al evento y sus límites son los de su ubicación. Las consumiciones (vouchers) tienen límites propios.");
        break;
      case url + "/staff":
        setTitulo("Staff");
        setSubtitulo(t("Gestionar personal"));
        break;
      case url + "/tickets":
        setTitulo("Tickets");
        setSubtitulo('');
        break;
      case location.pathname.match(new RegExp(`${url}/tickets/\\d+/accesos`)) ? location.pathname : '':
        setTitulo("Historial de Accesos");
        setSubtitulo('Visualizá todos los registros de entradas y salidas de este ticket.');
        break;
      case location.pathname.match(new RegExp(`${url}/tickets/\\d+`)) ? location.pathname : '':
        setTitulo("Ticket");
        setSubtitulo('');
        break;
      case url + "/vouchers":
        setTitulo("Vouchers");
        setSubtitulo('');
        break;
      case url + "/ventas":
        setTitulo("Ventas realizadas");
        setSubtitulo('');
        break;
      case url + "/cuentas":
        setTitulo("Cobros y pagos");
        setSubtitulo('Acá podés vincular las cuentas donde querés recibir los fondos de tus ventas. Seleccioná el medio de pago que usás y seguí los pasos para conectarlo.');
        break;
      case url + "/crear-cuenta":
        setTitulo(t("menuTemplate.wallet"));
        setSubtitulo(t("button.add"))
        break;
      case url + "/publicaciones":
        setTitulo(t("menuTemplate.publications"));
        setSubtitulo('Acá vas a completar y editar la información que se muestra en la tarjeta de tu evento en el inicio de la plataforma. Esa tarjeta incluye la imagen, el título y el resumen breve del evento que verán todos los usuarios.')
        break;
      case url + "/preguntas-frecuentes":
        setTitulo("Preguntas frecuentes");
        setSubtitulo("Se muestran en la página pública del evento. Respondé lo que más te consultan: horarios, accesos, edad mínima... Arrastrá para reordenarlas.");
        break;
      case url + "/publicaciones/nueva":
        setTitulo(t("menuTemplate.publications"));
        setSubtitulo(t("button.create"))
        break;
      case url + "/colaboradores":
        setTitulo(t("menuTemplate.collaborators"));
        setSubtitulo('');
        break;
      case url + "/nuevoVoucher":
        setTitulo('Vouchers');
        setSubtitulo(t("button.create"));
        break;
      case url + "/nuevoVoucher/importarExcel":
        setTitulo('Vouchers');
        setSubtitulo(t("excelImport.massiveCreation"));
        break;
      case url + "/nuevoTicket":
        setTitulo('Ticket');
        setSubtitulo(t("button.create"));
        break;
      case url + "/nuevoTicket/importarExcel":
        setTitulo('Ticket');
        setSubtitulo(t("excelImport.massiveCreation"));
        break;
      case url + "/nuevoTicket/recepcion":
        setTitulo('Ticket');
        setSubtitulo(t("excelImport.massiveCreation"));
        break;
      case url + "/editar":
        setTitulo("Datos del evento");
        setSubtitulo('');
        break;
      case url + "/mis-asistentes":
        setTitulo("Mis asistentes");
        setSubtitulo('Acá podés ver la lista de personas que escaneaste.');
        break;
      case url + "/caja":
        setTitulo("Caja");
        setSubtitulo('Acá podés asignar cajas a tus vendedores.');
        break;
      case url + "/stock":
        setTitulo("Stock");
        setSubtitulo('Acá podés manejar el stock de tus tarifas.');
        break;
      case url + "/ventas-caja":
        setTitulo("Historial de Ventas");
        setSubtitulo('Acá podés ver el historial de ventas realizadas de forma presencial.');
        break;
      case url + "/colaboradores-accesos":
        setTitulo("Accesos para colaboradores");
        setSubtitulo('Acá podés indicar qué tarifas pueden escanear los colaboradores.');
        break;
      case url + "/canales":
        setTitulo("Canales de venta");
        setSubtitulo("Repartí un link o un código a cada canal (academias, promotores, anuncios) y mirá cuánto vende cada uno.");
        break;
      case url + "/meta-pixel":
        setTitulo("Meta Pixel");
        setSubtitulo("Medí tus anuncios de Facebook e Instagram: visitas, compras iniciadas y compras con su importe.");
        break;
      case url + "/impresion":
        setTitulo("Diseño de Tickets");
        setSubtitulo("Elegí el tipo de ticket que querés usar para tu evento (tarjeta o pulsera) y personalizalo con toda la info importante.");
        break;
      case url + "/solicitudes":
        setTitulo("Solicitudes de tickets");
        setSubtitulo("Acá aparecen todas las solicitudes enviadas por los usuarios para los tickets que requieren aprobación. Revisá la información y decidí si aprobás o rechazás cada una.");
        break;
      default:
        setIcono('');
        setTitulo('');
        setSubtitulo('');
        break;
    }
  }, [location.pathname, param.id, t]);

  const handleGoBack = () => {
    if (location.pathname.split('/').length > 4) {
      const basePath = location.pathname.split('/').slice(0, 4).join('/');
      history.push(basePath);
    } else {
      history.push(`/eventos/${param.id}`);
    }
  }
  return (
    <>
      {!isVentaPresencial && !esVendedorOTesorero && (
        <header
        >
          <div className="d-flex flex-column" style={{ padding: "25px 35px" }}>
            {showBackButton && (
              <div className="mb-3">
                <Tooltip title="Volver">
                  <IconButton
                    onClick={handleGoBack}
                    size="small"
                    sx={{
                      color: "#5656ff",
                      border: "none",
                      borderRadius: "4px",
                      padding: "4px 12px",
                      "&:hover": {
                        backgroundColor: "rgba(11, 0, 98, 0.04)"
                      }
                    }}
                  >
                    <ArrowBack fontSize="small" />
                    <span style={{
                      marginLeft: "4px",
                      fontSize: "14px",
                      fontFamily: "Bricolage Grotesque, serif"
                    }}>
                      Volver
                    </span>
                  </IconButton>
                </Tooltip>
              </div>
            )}

            {!esVendedorOTesorero && (titulo.length !== 0 || subtitulo.length !== 0) && (
              <div className="d-flex align-items-center">
                <div className="d-flex justify-content-between align-items-center" style={{ flex: 1 }}>
                  <div className="d-flex">
                    <div>
                      <h2 style={{ margin: "0px", display: "flex", alignItems: "center", fontWeight: "500", color: "#0b0062" }}>{titulo}</h2>
                      {subtitulo.length !== 0 && (
                        <h6  style={{ marginTop:"10px",}} className="text-secondary fw-normal">{subtitulo}</h6>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </header>
      )}
    </>

  )
}